import PropTypes from 'prop-types'
import React, { Component } from 'react'

import * as PaymentLinks from '../../store/PaymentLinks'
import { routerActions } from 'connected-react-router'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import RefreshButton from '../../components/RefreshButton'
import { Table, Button } from 'semantic-ui-react'

class PaymentLinkList extends Component {
    constructor(props) {
        super(props)

        this.onAddClick = this.onAddClick.bind(this)
    }

    componentDidMount() {
        const { actions } = this.props
        console.log('PaymentLinkList', actions)
        actions.getProducts()
    }

    onAddClick(e) {
        const { actions } = this.props
        actions.push('/admin/paymentLink/add')
    }

    render() {
        const { paymentLink, actions } = this.props

        return (
            <div>
                <Table>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell textAlign="center">Payment Links</Table.HeaderCell>
                            <Table.HeaderCell colSpan={2}>
                                <RefreshButton floated="right" action={async () => await actions.getPaymentLinks()} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {Object.values(paymentLink.paymentLinks)
                            .filter((link) => link.isActive)
                            .map((f, index) => (
                                <Table.Row>
                                    <Table.Cell>{f.name}</Table.Cell>
                                    <Table.Cell>{f.isActive}</Table.Cell>
                                    <Table.Cell>
                                        <a href={f.url}>Payment Link</a>
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                    </Table.Body>
                    <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell />
                            <Table.HeaderCell colSpan={2}>
                                <Button floated="right" content="Add" onClick={this.onAddClick} />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                </Table>
            </div>
        )
    }
}

PaymentLinkList.propTypes = {
    paymentLink: PropTypes.object,
    actions: PropTypes.object,
}

const mapStateToProps = (state, ownProps) => {
    return {
        paymentLink: PaymentLinks.selector(state),
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: {
        ...bindActionCreators(PaymentLinks.actionCreators, dispatch),
        ...bindActionCreators(routerActions, dispatch),
    },
})

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(PaymentLinkList)
)
